import React, { useLayoutEffect } from 'react';
import { Policy, StyledLink } from './register-policy.styles';
import { useFilesListNoAuthSharedQuery } from '@entities/file/libs/hooks/use-files-list-no-auth-shared-query/use-files-list-no-auth-shared-query';
import { getFileUrlByCode } from '@entities/file/libs/hooks/use-files-list-no-auth-shared-query/get-file-url-by-code';
import { DOCUMENTS_LIST } from '@entities/file/config/documents-constants';
import { DEFAULT_PARAMETERS } from './constants';

export const RegisterPolicy: React.FC = () => {
    const [getFilesNoAuthList, getFilesNoAuthListResult] = useFilesListNoAuthSharedQuery(DEFAULT_PARAMETERS);
    const filesData = getFilesNoAuthListResult.data?.items || [];

    useLayoutEffect(() => {
        getFilesNoAuthList(DEFAULT_PARAMETERS);
    }, []);

    return (
        <Policy size='body2_long' color='neutral_30'>
            Нажимая кнопку отправить, вы соглашаетесь c условиями{' '}
            <StyledLink href={getFileUrlByCode(filesData, DOCUMENTS_LIST.USER_AGREEMENT)}>
                пользовательского соглашения
            </StyledLink>{' '}
            и{' '}
            <StyledLink href={getFileUrlByCode(filesData, DOCUMENTS_LIST.PRIVACY_POLICY)}>
                политикой конфиденциальности
            </StyledLink>
        </Policy>
    );
};
